import { api } from '@/lib/axios';

export interface UploadResult {
  url: string;
  filename: string;
}

/** Téléverse un fichier (image ou PDF) et retourne son URL publique. */
export async function uploadFile(file: File): Promise<UploadResult> {
  const form = new FormData();
  form.append('fichier', file);
  const { data } = await api.post<UploadResult>('/uploads', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
